import styled from 'styled-components';
import { Typography } from '@mui/material';
import { RunStatus } from '../../types';
import {
  formatShortDateTime,
  formatTimeValue,
  localizeDate,
} from '../../utils/datetime';
import ChartTooltip from '../ChartTooltip';
import { StatusChip } from '../Chip';
import { fontSize, fontWeight, space } from '../../style/utils';
import { MaterializationWindowRegion } from './hooks/useChartMaterialization';

// Anchored to the hovered pointer position (relative to the chart container)
// and lifted above the cursor, so it tracks the window instead of sitting in
// a fixed chart corner.
const Wrapper = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  transform: translate(-50%, calc(-100% - 12px));
  z-index: 10;
  pointer-events: none;
  width: max-content;
  white-space: nowrap;

  & > div {
    padding: ${space('md', 'lg')};
  }
`;

type Props = {
  region: MaterializationWindowRegion;
  status: RunStatus;
  x: number;
  y: number;
};

const MaterializationChartTooltip = ({ region, status, x, y }: Props) => (
  <Wrapper $x={x} $y={y}>
    <ChartTooltip>
      <Typography
        sx={{
          fontWeight: fontWeight('semibold'),
          fontSize: fontSize('lg'),
          mb: 1,
        }}
      >
        Materialization window
      </Typography>
      {region.isAnomalous && (
        <StatusChip
          sx={{ mb: 2 }}
          status={status === 'warn' ? 'warn' : 'fail'}
        />
      )}
      <Typography sx={{ mb: 1 }}>
        {`${formatShortDateTime(localizeDate(region.startTime))} - ${
          region.restoreTime
            ? formatShortDateTime(localizeDate(region.restoreTime))
            : 'Ongoing'
        }`}
      </Typography>
      {!region.isOngoing && (
        <Typography>
          {`Empty for: ${formatTimeValue((region.end - region.start) / 1000)}`}
        </Typography>
      )}
    </ChartTooltip>
  </Wrapper>
);

export default MaterializationChartTooltip;
